import { render, staticRenderFns } from "./class-composes.vue?vue&type=template&id=761bf1bf&scoped=true"
import script from "./class-composes.vue?vue&type=script&lang=js"
export * from "./class-composes.vue?vue&type=script&lang=js"
import style0 from "./class-composes.vue?vue&type=style&index=0&id=761bf1bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761bf1bf",
  null
  
)

export default component.exports